module.exports = __webpack_public_path__ + "img/girlsDesk.e96c8e68.jpg";